module.exports = __webpack_public_path__ + "img/fundermax.fd6d68f4.jpg";